import Banner from "./Banner";
import AboutSection from "./About-section";
import Solution from "./Solution";
import WhySection from "./WhySection";
import AccreditationSection from "./AccreditationSection";
import Cta from "./Cta";
import Blogs from "./Blogs";
import Social from "./Social";

const Home = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <AboutSection language={language} />
      <WhySection language={language} />
      <Social language={language} />
      <Solution language={language} />
      <AccreditationSection language={language} />
      <Cta language={language} />
      <Blogs language={language} />
    </>
  );
};

export default Home;